export const grayscale = (c) => {
    const avg = (c.r + c.g + c.b) / 3;
    c.r = c.g = c.b = avg;
};
